import styled from 'styled-components';
import React, {FC, useState, useCallback, ChangeEvent} from 'react';
import {
  fontFamiliesR4,
  paletteR4,
  paletteR4Secondary,
  fontSizesMixinsR4
} from '../../../../lib/styleVariablesR4';
import {SecondaryButton} from '../../../molecules/buttonsR4';
import {Input} from '../../../molecules/inputs';
import {mediaBreakpointDown, mediaBreakpointUp, fontWeights} from '../../../../lib/styleVariables';

export interface NavigationCallToActionR4FrontPageProps {
  title: React.ReactNode;
  inputPlaceholder: string;
  onSubmit: (inputValue: string) => void;
  buttonLabel: string;
}

const StyledCTAWrapper = styled.div`
  width: 100%;
  max-width: 720px;
  padding: 200px 0px 240px;

  ${mediaBreakpointDown('desktop')} {
    padding: 98px 0px 120px;
  }

  ${mediaBreakpointDown('tablet')} {
    padding: 86px 32px 112px;
  }
`;

const StyledCTATitleWrapper = styled.div`
  margin: 0 24px;

  ${mediaBreakpointDown('mobile')} {
    margin: 0;
  }
`;

const StyledCTATitle = styled.h4`
  ${fontSizesMixinsR4.h2()};
  font-family: ${fontFamiliesR4.frontPageTitle};
  font-weight: ${fontWeights.medium};
  font-size: 52px;
  line-height: 64px;
  color: ${paletteR4Secondary.black.base};
  text-align: center;
  margin: 0;
  ${mediaBreakpointDown('mobile')} {
    font-size: 38px;
    line-height: 42px;
    text-align: left;
    font-weight: ${fontWeights.medium};
  }
`;

const StyledForm = styled.div`
  border: 2px solid ${paletteR4.black.base};
  background: ${paletteR4.white.base};
  display: flex;
  height: 52px;
  margin: 48px auto 0;
  overflow: hidden;

  ${mediaBreakpointUp('tablet')} {
    max-width: 70%;
    border-radius: 100px;
  }

  ${mediaBreakpointDown('mobile')} {
    height: auto;
    flex-direction: column;
    margin: 32px 0 0;
    border: none;
  }
`;

const inputWrapperStyle = `
  flex: 1;
`;

const StyledInput = styled(Input)`
  background-color: ${paletteR4.white.base};
  font-weight: ${fontWeights.semibold};
  color: ${paletteR4Secondary.black.base};
  font-size: 16px;
  border: none;
  padding: 12px 24px;
  height: 100%;

  &::-webkit-input-placeholder {
    color: ${paletteR4.gray.base};
  }

  ${mediaBreakpointDown('mobile')} {
    border: 2px solid ${paletteR4.black.base};
    border-radius: 100px;
    text-align: center;
    padding: 12px;
    height: 52px;
  }
`;

const StyledFieldButton = styled(SecondaryButton)`
  font-weight: ${fontWeights.semibold};
  margin-top: -2px;
  border-radius: 8px 100px 100px 8px;
  padding: 12px 36px;

  ${mediaBreakpointDown('mobile')} {
    border-radius: 100px;
    margin-top: 16px;
    margin-left: 0;
    height: 52px;
  }
`;
export const NavigationCallToActionR4FrontPage: FC<NavigationCallToActionR4FrontPageProps> = props => {
  const {title, onSubmit: onButtonClick, inputPlaceholder, buttonLabel} = props;
  const [email, setEmail] = useState<string>('');

  const onEmailChange = (event: ChangeEvent<HTMLInputElement>) => {
    setEmail(event.target.value);
  };

  const onClickHandler = useCallback(() => {
    onButtonClick(email);
  }, [email, onButtonClick]);

  return (
    <StyledCTAWrapper>
      <StyledCTATitleWrapper>
        <StyledCTATitle>{title}</StyledCTATitle>
      </StyledCTATitleWrapper>
      <StyledForm>
        <StyledInput
          placeholder={inputPlaceholder}
          type="email"
          required
          name="email"
          onChange={onEmailChange}
          wrapperCss={inputWrapperStyle}
        />
        <StyledFieldButton onClick={onClickHandler} isHover>
          {buttonLabel}
        </StyledFieldButton>
      </StyledForm>
    </StyledCTAWrapper>
  );
};
